export class ExpenseTypes {
  static FILE = 'FILE'
  static INVOICE = 'INVOICE'
  static TRANSACTION_JUSTIFIED = 'TRANSACTION_JUSTIFIED'
  static TRANSACTION_UNJUSTIFIED = 'TRANSACTION_UNJUSTIFIED'
}
